import { useState } from "react";
import { URLS } from "../../_config";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import Icon from "../../components/icons";
import Layout from "../layout";
import RightAddEscalations from "./RightAddEscalations";
import RightFilter from "./RightFilter";

const RequestResolution = () => {
    const [showAddEscalationsRight, setShowAddEscalationsRight] = useState<any>(null);
    const [showFilterRight, setShowFilterRight] = useState<any>(null);


    const handleClose = () => setShowAddEscalationsRight(null);
    const handleCloseFilter = () => setShowFilterRight(null);

    return (
        <Layout>
            <div className="container-fluid" data-aos="fade-up" data-aos-duration="1000">
             <Breadcrumbs title="Request Resolution" breadcrumbs={{ Home: URLS.PROFILE, 'Request Resolution': "#" }} /> 
                {/* <div className="page-title-box d-flex align-items-center justify-content-between">


                    <div className="d-flex align-items-center gap-15">
                        <h1 className="mb-0 text-xxl"> Request  <span className="text-accent">Resolution</span></h1>
                        <div className="btn-group">
                            <button type="button" className="btn btn-secondary dropdown-toggle rate_checker" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Rate Calculator <i className="mdi mdi-chevron-down"></i></button>
                            <div className="dropdown-menu">
                                <a className="dropdown-item" href="#">Polly Rate Checker</a>
                                <div className="dropdown-item multidropdown">Lender Price Rate Checker
                                    <ul>
                                        <li>
                                            <a href="#">275 BPS</a>
                                        </li>
                                        <li>
                                            <a href="#">200 BPS</a>
                                        </li>
                                        <li>
                                            <a href="#">0 BPS</a>
                                        </li>
                                        <li>
                                            <a href="#">Account</a>
                                        </li>
                                        <li>
                                            <a href="#">Powered by <strong>Lender Price</strong></a>
                                        </li>
                                    </ul>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="page-title-right">
                        <ol className="breadcrumb m-0">
                            <li className="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                            <li className="breadcrumb-item active">Request Resolution</li>
                        </ol>
                    </div>

                </div> */}

                <div className="row my-escalations-block">
                    <div className="col-lg-3">
                        <div className="card mini-stats-wid">
                            <div className="card-body card-accent d-flex align-items-center">

                                <div className="d-flex align-items-center gap-30">
                                    <div className="card-left-icons">
                                        <img src="assets/images/icons/total-escalations.svg" />
                                    </div>
                                    <div className="mr-3">
                                        <p className="text-muted mb-2">Total RequestResolution</p>
                                        <h5 className="mb-0">120</h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <div className="card blog-stats-wid">
                            <div className="card-body card-black d-flex align-items-center">
                                <div className="d-flex align-items-center gap-30">
                                    <div className="card-left-icons">
                                        <img src="assets/images/icons/not-started.svg" />
                                    </div>
                                    <div className="mr-3">
                                        <p className="text-muted mb-2">NOT STARTED</p>
                                        <h5 className="mb-0">86</h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="card blog-stats-wid">
                            <div className="card-body card-purple d-flex align-items-center">
                                <div className="d-flex align-items-center gap-30">
                                    <div className="card-left-icons">
                                        <img src="assets/images/icons/started-icon.svg" />
                                    </div>
                                    <div className="mr-3">
                                        <p className="text-muted mb-2">STARTED</p>
                                        <h5 className="mb-0">1,534</h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="card blog-stats-wid">
                            <div className="card-body card-green d-flex align-items-center">
                                <div className="d-flex align-items-center gap-30">
                                    <div className="card-left-icons">
                                        <img src="assets/images/icons/complete-icon.svg" />
                                    </div>
                                    <div className="mr-3">
                                        <p className="text-muted mb-2">COMPLETED</p>
                                        <h5 className="mb-0">4,235</h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between mb-3 flex-col-sm">
                                    <h2 className="font-size-16">My RequestResolution List</h2>
                                    <div className="d-flex gap-2">
                                        <button className="btn btn-secondary d-flex gap-2 align-items-center right-bar-toggle" onClick={() => setShowFilterRight(true)}><i className="bx bx-filter-alt"></i> Filter</button>
                                        <button className="btn btn-light-secondary d-flex gap-2 align-items-center right-add-bar-toggle" onClick={() => setShowAddEscalationsRight(true)}><Icon name="plus" /> Add New Resolution</button>
                                    </div>

                                </div>
                                <div className="table-responsive">
                                    <table id="datatable" className="table table-bordered table-striped dt-responsive nowrap" style={{ borderCollapse: 'collapse', borderSpacing: '0', width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Description</th>
                                                <th>Category</th>
                                                <th>By</th>
                                                <th>Status</th>
                                                <th>Support Staff</th>
                                                <th>Last Status Update</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>


                                        <tbody>
                                            <tr>
                                                <td>203895
                                                    <small>26 days ago</small></td>
                                                <td>"Apply Now" to be attached to QR code
                                                    "Apply Now" to be attached to QR code</td>
                                                <td>NEXA → Marketing</td>
                                                <td>Caleb Olawuyi</td>
                                                <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                                <td></td>
                                                <td>5 days ago</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <a href="#"><i className="assign-btn"></i></a>
                                                        <a href="#"><i className="msg-btn"></i></a>
                                                        <a href="#"><i className="edit-btn"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>203895
                                                    <small>26 days ago</small></td>
                                                <td>"Apply Now" to be attached to QR code
                                                    "Apply Now" to be attached to QR code</td>
                                                <td>NEXA → Marketing</td>
                                                <td>Caleb Olawuyi</td>
                                                <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                                <td></td>
                                                <td>5 days ago</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <a href="#"><i className="assign-btn"></i></a>
                                                        <a href="#"><i className="msg-btn"></i></a>
                                                        <a href="#"><i className="edit-btn"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>203895
                                                    <small>26 days ago</small></td>
                                                <td>"Apply Now" to be attached to QR code
                                                    "Apply Now" to be attached to QR code</td>
                                                <td>NEXA → Marketing</td>
                                                <td>Caleb Olawuyi</td>
                                                <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                                <td></td>
                                                <td>5 days ago</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <a href="#"><i className="assign-btn"></i></a>
                                                        <a href="#"><i className="msg-btn"></i></a>
                                                        <a href="#"><i className="edit-btn"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>203895
                                                    <small>26 days ago</small></td>
                                                <td>"Apply Now" to be attached to QR code
                                                    "Apply Now" to be attached to QR code</td>
                                                <td>NEXA → Marketing</td>
                                                <td>Caleb Olawuyi</td>
                                                <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                                <td></td>
                                                <td>5 days ago</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <a href="#"><i className="assign-btn"></i></a>
                                                        <a href="#"><i className="msg-btn"></i></a>
                                                        <a href="#"><i className="edit-btn"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>203895
                                                    <small>26 days ago</small></td>
                                                <td>"Apply Now" to be attached to QR code
                                                    "Apply Now" to be attached to QR code</td>
                                                <td>NEXA → Marketing</td>
                                                <td>Caleb Olawuyi</td>
                                                <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                                <td></td>
                                                <td>5 days ago</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <a href="#"><i className="assign-btn"></i></a>
                                                        <a href="#"><i className="msg-btn"></i></a>
                                                        <a href="#"><i className="edit-btn"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>203895
                                                    <small>26 days ago</small></td>
                                                <td>"Apply Now" to be attached to QR code
                                                    "Apply Now" to be attached to QR code</td>
                                                <td>NEXA → Marketing</td>
                                                <td>Caleb Olawuyi</td>
                                                <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                                <td></td>
                                                <td>5 days ago</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <a href="#"><i className="assign-btn"></i></a>
                                                        <a href="#"><i className="msg-btn"></i></a>
                                                        <a href="#"><i className="edit-btn"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>203895
                                                    <small>26 days ago</small></td>
                                                <td>"Apply Now" to be attached to QR code
                                                    "Apply Now" to be attached to QR code</td>
                                                <td>NEXA → Marketing</td>
                                                <td>Caleb Olawuyi</td>
                                                <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                                <td></td>
                                                <td>5 days ago</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <a href="#"><i className="assign-btn"></i></a>
                                                        <a href="#"><i className="msg-btn"></i></a>
                                                        <a href="#"><i className="edit-btn"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>203895
                                                    <small>26 days ago</small></td>
                                                <td>"Apply Now" to be attached to QR code
                                                    "Apply Now" to be attached to QR code</td>
                                                <td>NEXA → Marketing</td>
                                                <td>Caleb Olawuyi</td>
                                                <td><span className="badge badge-pill badge-soft-success font-size-12">Open</span></td>
                                                <td></td>
                                                <td>5 days ago</td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <a href="#"><i className="assign-btn"></i></a>
                                                        <a href="#"><i className="msg-btn"></i></a>
                                                        <a href="#"><i className="edit-btn"></i></a>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>





            <RightAddEscalations show={showAddEscalationsRight} handleClose={handleClose} />
            <RightFilter show={showFilterRight} handleClose={handleCloseFilter} />

        </Layout>
    );
}


export default RequestResolution;
